/**
 * ConcoursBf — Forum service (frontend)
 */
import apiClient from './apiClient';

export async function getTopics({ category, authorId, sort } = {}) {
  const params = new URLSearchParams({ sort: sort || 'newest' });
  if (category && category !== 'all') params.set('category', category);
  if (authorId) params.set('authorId', authorId);
  return apiClient(`/forum/topics?${params.toString()}`);
}

export async function getTopicById(id) {
  return apiClient(`/forum/topics/${id}`);
}

export async function createTopic(topic) {
  return apiClient('/forum/topics', {
    method: 'POST',
    body: JSON.stringify(topic),
  });
}

export async function updateTopic(id, updates) {
  return apiClient(`/forum/topics/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
}

export async function deleteTopic(id) {
  return apiClient(`/forum/topics/${id}`, {
    method: 'DELETE',
  });
}

export async function createResponse(topicId, response) {
  return apiClient(`/forum/topics/${topicId}/responses`, {
    method: 'POST',
    body: JSON.stringify(response),
  });
}

export async function updateResponse(topicId, responseId, updates) {
  return apiClient(`/forum/topics/${topicId}/responses/${responseId}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
}

export async function deleteResponse(topicId, responseId) {
  return apiClient(`/forum/topics/${topicId}/responses/${responseId}`, {
    method: 'DELETE',
  });
}
